import { useCallback } from 'react';
import styled from '@emotion/styled';
import { Typography, Button, Flex } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';

type AuthErrorOverlayProps = {
  orgSlug?: string;
  isOrgNotFound: boolean;
  hasQueryError: boolean;
};

export const AuthErrorOverlay = ({
  orgSlug,
  isOrgNotFound,
  hasQueryError,
}: AuthErrorOverlayProps): JSX.Element => {
  const { t } = useTranslation('common');

  const handleRetry = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <Container align="center" justify="center" vertical>
      <Typography.Title level={2}>
        {isOrgNotFound
          ? t('errors.invalid_org_slug', { orgSlug })
          : t('errors.generic_error_heading')}
      </Typography.Title>
      {hasQueryError && (
        <>
          <Message>{t('errors.data_load_error_message')}</Message>
          <Button type="primary" onClick={handleRetry}>
            {t('errors.retry_button')}
          </Button>
        </>
      )}
    </Container>
  );
};

const Container = styled(Flex)`
  height: 100%;
  width: 100%;
  padding: 48px 0 96px;
  text-align: center;
`;

const Message = styled(Typography.Text)`
  margin: 0 0 24px;
  color: #666;
  max-width: 400px;
`;
